var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    _vm.$style.item,
    ( _obj = {}, _obj[_vm.$style.itemActive] = _vm.active, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.itemDisabled] = _vm.disabled, _obj$1 )
  ]},[_c('input',{class:_vm.$style.input,attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.active},on:{"click":function($event){return _vm.$emit('change', !_vm.active)}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }